export default __webpack_public_path__ + "static/media/p2023-8.d677eef8.jpeg";